export default __webpack_public_path__ + "static/media/logo.9bc8753a.svg";